import { getCollegeInitials } from "../../utils/collegeHelpers";

const sizeStyles = {
  sm: "h-10 w-10 text-[11px]",
  md: "h-12 w-12 text-xs",
  lg: "h-14 w-14 text-sm"
};

function LogoPlaceholder({ name, size = "md", className = "" }) {
  const initials = getCollegeInitials(name);
  const sizeClassName = sizeStyles[size] || sizeStyles.md;

  return (
    <span
      className={`inline-flex ${sizeClassName} items-center justify-center rounded-xl border border-brand-line bg-gradient-to-br from-brand-navy to-brand-navy-soft font-semibold tracking-[0.06em] text-white shadow-card ${className}`.trim()}
      aria-label={`${name} initials`}
      title={name}
    >
      {initials}
    </span>
  );
}

export default LogoPlaceholder;
